import { createOperation } from "src/features/operations";
import { State as MarketingState } from "./marketing";
export { reducer as marketingReducer } from "./marketing";
export const marketingMetaDataOperation = createOperation<void>("MARKETING/SHOULD_PROMPT_MARKETING");
export const sendMarketingOptIn = createOperation<void>("MARKETING/SEND_MARKETING_OPT_IN", { showSpinner: true });
export const fetchTermsUpdateOperation = createOperation<void>("MARKETING/SHOULD_PROMPT_ACCEPT_TERMS_UPDATE");
export const acceptTermsUpdateOperation = createOperation<void>("MARKETING/SEND_ACCEPT_TERMS_UPDATE");

export type State = MarketingState;
